import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Toaster } from 'react-hot-toast';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import DefaultLayout from './components/DefaultLayout';
import appTheme from './theme/appTheme';

function App() {
  return (
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Toaster position="top-right" toastOptions={{ duration: 4000 }} />
        <Router>
          <DefaultLayout />
        </Router>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
